import React, { useState }  from 'react';
import { Row, Col, DragCardGroup, DragCard, Card, Tile } from '@cv/eds-react';
import './DynamicLayout.css';
import { setMaxMinChartToggle } from '../Charts/reducer';
import { connect, useDispatch } from 'react-redux';
import { useMemo } from 'react';

function DynamicLayout({ cards }) {

  const [mapToggleMaxMin, setMapToggleMaxMin] = useState(false)
  const dispatch = useDispatch();
  
  const dragCardGroupDropHandler = () => {
    // handle drop event here
  };

  const setMaxMin = async() => {
    dispatch(setMaxMinChartToggle(!mapToggleMaxMin))
    setMapToggleMaxMin(!mapToggleMaxMin)
  }

  const emptyContainer = () => {
    // handle empty container here
  };

  const renderCardComponent = (component, index, Mzoom) => {
    const Component = component;
    return Component && <Component key={index} className='card-content' zoom={Mzoom ? Mzoom : null} />;
  };

  const RenderCards = () => {
    return cards?.map((card, index) => {
      const { component, title, span, subtitle } = card;
      return (
        card.chartProps?.type?.toLowerCase() === 'x-infra-map' && mapToggleMaxMin ? <>
          <Card className={card.chartProps?.type?.toLowerCase() === 'x-infra-map' && mapToggleMaxMin ? 'maximiseMap' : 'minimiseMap'}>{renderCardComponent(component, index, 7)}
            <i onClick={() => setMapToggleMaxMin(!mapToggleMaxMin)} className={`icon minIcon ${mapToggleMaxMin ? 'icon-minimize' : 'icon-maximize'}`}></i>
          </Card>
        </>
          :
        <Col key={index} span={span}  className='card-grid'>
          {/* <DragCard
            className="drop-card"
            emptyContainer={emptyContainer}
            style={{ height: '100%', minHeight: '100%' }}
          > */}
            <Card key={index} title={title} subtitle={subtitle}>
            {renderCardComponent(component, index, mapToggleMaxMin ? 7 : null)}
            <i onClick={() => setMaxMin()} className={`icon ${card.chartProps?.type?.toLowerCase() === 'x-infra-map' ? `mapMaxIconShow ${mapToggleMaxMin ? 'minIcon' : 'maxIcon'}` : 'mapMaxIconHide'} ${mapToggleMaxMin ? 'icon-minimize' : 'icon-maximize'}`}></i>
          </Card>
          {/* </DragCard> */}
        </Col>
      );
    });
  };

  return (
    <div className="dashCards">
      {/* <Tile  noMargins> */}
      {/* <DragCardGroup id="drop-card" dropHandler={dragCardGroupDropHandler}> */}
      <Row gutter={1}>{RenderCards()}</Row>
      {/* </DragCardGroup> */}
      {/* </Tile> */}
    </div>
  );
}

const mapDispatchToProps = {
  setMaxMinChartToggle
}

// export default DynamicLayout;
export default connect(setMaxMinChartToggle)(React.memo(DynamicLayout));

